module.exports = __webpack_public_path__ + "img/it.9b7b9079.jpg";